<template>
  <el-container
    v-loading="loading"
    style="height:100%"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-main>
        <el-row>
          <!-- 左侧区域 -->
          <el-col :span="24" style="height: 100%">
            <div class="ik-mendian-warp right">
              <el-card class="box-card storeinfo-box-card-mendian">
                <div slot="header" class="clearfix" style="height:17px;">
                  <div class="left"><span class="card-title">门店信息</span></div>
                  <div class="right" style="margin-top:-5px;">
                    <el-button v-if="data.head.stateSign !== '2'" class="ik-user-btn" size="mini" type="primary" @click="update">修改信息</el-button>
                    <el-button v-if="data.head.stateSign !== '2'" class="ik-user-btn" size="mini" type="primary" @click="find">取消</el-button>
                  </div>
                </div>
                <el-form
                  id="ik-info-head"
                  :ref="data.head"
                  v-model="data.head"
                  class="ik-info-head"
                  :inline="true"
                  label-width="120px"
                  :disabled="false"
                >
                  <el-row>
                    <el-col :span="6">
                      <ik-form-text
                        :ref="'input_name'"
                        v-model="data.head['name']"
                        code="name"
                        name="诊所名称"
                        default-value=""
                        :min-length="0"
                        :max-length="50"
                        :disabled="true"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-text
                        :ref="'input_contactPhone'"
                        v-model="data.head['contactPhone']"
                        code="contactPhone"
                        name="联系电话"
                        default-value=""
                        :min-length="0"
                        :max-length="50"
                        :disabled="data.head['stateSign'] === '2'"
                        :rules="[{ code: 'phone', message: '手机格式不正确'}]"
                        :require="true"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-text
                        :ref="'input_contactEmail'"
                        v-model="data.head['contactEmail']"
                        code="contactEmail"
                        name="联系邮箱"
                        default-value=""
                        :min-length="0"
                        :max-length="50"
                        :disabled="data.head['stateSign'] === '2'"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-text
                        :ref="'input_longitude'"
                        v-model="data.head['longitude']"
                        code="longitude"
                        name="经度"
                        default-value=""
                        :min-length="0"
                        :max-length="50"
                        :disabled="data.head['stateSign'] === '2'"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-text
                        :ref="'input_latitude'"
                        v-model="data.head['latitude']"
                        code="latitude"
                        name="纬度"
                        default-value=""
                        :min-length="0"
                        :max-length="50"
                        :disabled="data.head['stateSign'] === '2'"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-text
                        :ref="'input_contactEmail'"
                        v-model="data.head['contactEmail']"
                        code="contactEmail"
                        name="联系邮箱"
                        default-value=""
                        :min-length="0"
                        :max-length="50"
                        :disabled="data.head['stateSign'] === '2'"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-select
                        :ref="'input_stateSign'"
                        v-model="data.head['stateSign']"
                        code="stateSign"
                        name="状态标识"
                        default-value="1"
                        key-field="key"
                        value-field="value"
                        :options="toJson(jsonStr.stateSign)"
                        :disabled="true"
                        :require="false"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="24">
                      <ik-form-text
                        :ref="'input_contactAddress'"
                        v-model="data.head['contactAddress']"
                        code="contactAddress"
                        name="联系地址"
                        default-value=""
                        :min-length="0"
                        :max-length="100"
                        :require="true"
                        :disabled="data.head['stateSign'] === '2'"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-image-oss
                        :ref="'input_registrationLicense'"
                        v-model="data.head['registrationLicense']"
                        code="registrationLicense"
                        name="备案凭证"
                        default-value=""
                        :disabled="data.head['stateSign'] === '2'"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                    <el-col :span="6">
                      <ik-form-image-oss
                        :ref="'input_storeLicense'"
                        v-model="data.head['storeLicense']"
                        code="storeLicense"
                        name="营业执照"
                        default-value=""
                        :disabled="data.head['stateSign'] === '2'"
                        @onFieldChange="onFieldChange"
                      />
                    </el-col>
                  </el-row>
                </el-form>
                <div>
                  <AddMap
                    :initial-center="mapCenter"
                    :data="data"
                    @marker-position="handleMarkerPosition"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <el-row class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
// import TinymceEditor from '@/components/TinymceEditor'
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormImageOss from '@/components/ik/form/input/IkFormImageOss'
import store from '@/store'
import { findPage, update } from '@/api/ik/data/dataApi'
import AddMap from '@/components/map.vue'
export default {
  components: {
    /*
    IkColumnNumber
    TinymceEditor,
    */
    IkFormText,
    IkFormSelect,
    IkFormImageOss,
    AddMap
  },
  props: {
  },
  data() {
    return {
      bgPath: 'base/user/user/store',
      content: '',
      tinymceInit: {
        language: 'zh_CN', // 中文
        height: 500,
        menubar: 'file edit insert view format table tools help',
        toolbar: 'undo redo | bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | image media | link unlink | code',
        plugins: 'advlist autolink link image media lists charmap print preview hr anchor pagebreak spellchecker searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking save table directionality emoticons template paste textcolor importcss colorpicker textpattern'
      },
      loading: false,
      listLoading: false,
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 5
      },
      // Json字符串
      jsonStr: {
        stateSign: '[{"key": "1", "value": "未审核"}, {"key": "2", "value": "已审核"}]'
      },
      tableData: [],
      searcher: { 'id': '', 'code': '', 'name': '', 'storeId': '', 'storeCode': '', 'storeName': '' },
      // 当前数据
      data: {
        head: {}
      },
      // 验证器
      verify: {
        head: {},
        body: {}
      },
      mapCenter: {
        lat: 36.814114,
        lng: 118.054858
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.find()
  },
  methods: {
    contentChange(dt) {
      this.content = dt
    },
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    update() {
      const $this = this
      $this.listLoading = true
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      update($this.bgPath, $this.data).then(response => {
        $this.listLoading = false
        // 刷新数据
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已保存!'
        }).catch(() => {
          $this.listLoading = false
        })
      })
    },
    find() {
      const $this = this
      $this.listLoading = true
      // 获取树组件数据
      $this.searcher.code = store.getters['user/getStoreCode']
      findPage($this.bgPath, $this.searcher, 20, 1).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        $this.data.head = response.data.list[0]
        this.mapCenter = {
          lng: $this.data.head.longitude,
          lat: $this.data.head.latitude
        }
        // 设置加载完成
        $this.listLoading = false
      }).catch(response => {
        $this.listLoading = false
      })
    },
    handleMarkerPosition(pos) {
      this.data.head.latitude = pos.lat.toString()
      this.data.head.longitude = pos.lng.toString()
    }
  }
}
</script>
<style lang="scss" scoped>
.ik-user-item{overflow:hidden;position:relative;left:0px;top:0px;}
.ik-user{height:30px;padding-left:10px;padding-top:5px;line-height:25px;}
.ik-user-btn-warp{position:absolute;bottom:10px;right:10px;}
.el-row{height:100%;}
.box-card {width: 100%;height:100%;}
.card-title{color:#409EFF;}
.ik-mendian-warp{width: 100%;height:100%;}
.dialog-footer{position:absolute;right:10px;top:20px;}
.title-warp{line-height:25px;overflow:hidden;padding:5px 5px;}
.pop-line{border-top:1px solid #ccc;padding:5px 10px;font-size:12px;overflow:hidden;}
.pop-line.pop-line-first{border-top:0px solid #ccc;}
.pop-line .pop-line-item{padding:0px 10px;width:75px;margin:0px auto;text-align:center;height:16px;line-height:16px;}
.pop-line .pop-line-item.pop-line-item-first{font-size:13px;font-weight:bold;color:#409EFF;}
.pop-line .pop-line-item-8{padding:0px 10px;width:130px;margin:0px auto;text-align:center;height:16px;line-height:16px;}
.pop-line .pop-line-item-8.pop-line-item-first{font-size:13px;font-weight:bold;color:#409EFF;}
.pop-line .pop-line-item-6{padding:0px 10px;width:100px;margin:0px auto;text-align:center;height:16px;line-height:16px;}
.pop-line .pop-line-item-6.pop-line-item-first{font-size:13px;font-weight:bold;color:#409EFF;}
.ik-user-list {
  .ik-user-item {
    width: 100%;
    min-width: 150px;
    height: 100px;
    background-color: #1482f0;
    .ik-user-img {
      top: 20px;
    }
  }
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>
<style lang="scss" >
.treatment-el-tabs-huanzhe .el-tabs__content{height:calc(100% - 53px);overflow:auto;}
.treatment-box-card-user .el-card__body{height:calc(100% - 55px);overflow:auto;}
.treatment-box-card-zhenduan .el-card__body{height:calc(100% - 55px);overflow:auto;}
.storeinfo-box-card-mendian .el-card__body{height:calc(100% - 55px);}
.pop-line-warp{background-color:#e7f2fd;}
.treatment-info-head-huanzhe .el-form-item__content{width:calc(100% - 90px)}
.treatment-info-head-chufang .IkFormNumber .el-form-item__content{width:calc(100% - 90px)}
.treatment-info-head-chufang .ik-select .el-form-item__content{width:calc(100% - 90px)}
/* 布局样式 */
.el-aside {
  height: calc(100vh - 88px);
  width: 100%;
  border-right: 1px solid #1482f0;
}
.el-header, .el-footer {
  padding: 0px;
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
.el-header {
  height: 42px;
  border-bottom: 1px solid #1482f0;
}
.el-footer {
  height: 36px;
  .ik-list-pagination {
    background-color: #FFFFFF;
    color: #FFFFFF;
    height: 40px;
  }
  .ik-list-enterprise-info {
    font-size: 14px;
    line-height: 40px;
  }
}
.el-main {
  height: calc(100vh - 82px - 90px);
  padding: 0px;
}
/* 菜单样式 */
.ik-list-title{
  background-color: #FFFFFF;
  color: #1482f0;
  margin-left: 25px;
  width: 300px;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
}
.ik-list-menu {
  margin-top: 3px;
  margin-left: 20px;
  float: right;
}
.ik-list-menu-btn {
  background-color: #1482f0;
  color: #FFFFFF;
  border-radius:25px;
}
.el-form-item__error{position:static;}
</style>
